import { dayjs } from '@shared/utils';
import { z } from 'zod';

export const QSetUsageReportFilterSectionSchema = z
  .object({
    examStartDate: z
      .date({ message: 'กรุณาเลือก Exam Start Date' })
      .nullable()
      .refine((val) => val !== null, { message: 'กรุณาเลือก Exam Start Date' }),
    examEndDate: z
      .date({ message: 'กรุณาเลือก Exam End Date' })
      .nullable()
      .refine((val) => val !== null, { message: 'กรุณาเลือก Exam End Date' }),
    examCourse: z
      .object(
        {
          value: z.string(),
          label: z.string(),
        },
        { message: 'กรุณาเลือก Exam Course' },
      )
      .nullable()
      .refine((val) => val !== null, { message: 'กรุณาเลือก Exam Course' }),
  })
  .refine(
    (data) => {
      if (!data.examStartDate || !data.examEndDate) {
        return true; // Let individual field validation handle this
      }
      const startDate = dayjs(data.examStartDate);
      const endDate = dayjs(data.examEndDate);
      return endDate.isSameOrAfter(startDate, 'date');
    },
    {
      message: 'Exam End Date ต้องมากกว่าหรือเท่ากับ Exam Start Date',
      path: ['examEndDate'],
    },
  );

export type QSetUsageReportFilterSectionFormInput = z.input<
  typeof QSetUsageReportFilterSectionSchema
>;

export type QSetUsageReportFilterSectionFormOutput = z.output<
  typeof QSetUsageReportFilterSectionSchema
>;
